import { ColumnDefWithTooltip } from "src/components/Table/Table";
import type { OrganizationError } from "src/hooks/useOrganization";
import { formatIsoDateToOrgDate } from "src/services/format";
import type * as GQL from "src/types/graphql";
import type { RemoteData } from "src/types/remoteData";
import { ColumnId } from "./constants";

type Row = {
  schoolForm: { schoolSubmittedAt: timestamptz | null } | null;
};

export function buildSchoolSubmittedDateColumnDef<T extends Row>({
  organization,
}: {
  organization: RemoteData<OrganizationError, GQL.Organization>;
}): ColumnDefWithTooltip<T> {
  return {
    id: ColumnId.SchoolSubmittedDate,
    header: "School Submitted Date",
    cell: (props) =>
      formatIsoDateToOrgDate(
        props.row.original.schoolForm?.schoolSubmittedAt ?? null,
        organization
      ),
  };
}
